import { ChangeEvent } from 'react';
import Input from '@luna-protocol/core/src/components/Input/Input';
import styles from './CardRow.module.scss';
import { ApplicantDetailsForm } from '../../types';

type DealStatusCardRowProps = {
  label?: string;
  value?: string | number;
  isEditMode?: boolean;
  placeholder?: string;
  inputName?: keyof ApplicantDetailsForm;
  inputType?: 'number' | 'text' | 'password' | 'email' | 'tel' | 'currency' | 'date' | 'textarea' | undefined;
  handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  minDate?: string;
};

const CardRow = ({
  label,
  value,
  placeholder,
  inputName,
  inputType = 'text',
  isEditMode = false,
  handleChange,
  error,
  touched,
  minDate, 
}: DealStatusCardRowProps) => {
  return (
    <div className={styles.cardRow__container}>
      {label && (
        <div className={styles.cardRow__label}>
          <span>{label}</span>
        </div>
      )}
      <div>
        {isEditMode ? (
          <Input
            className={styles.cardRow__input}
            placeholder={placeholder}
            name={inputName}
            type={inputType}
            onChange={event => handleChange && handleChange(event)}
            value={value as string}
            error={error && !!touched ? error : undefined}
            min={inputType === 'date' ? minDate : undefined}
          />
        ) : (
          <div>
            <span className={styles.cardRow__readonlyValue}>
              {(() => {
                switch (inputType) {
                  case 'password':
                    return '********';
                  case 'date': {
                    if (value) {
                      const valueArr = String(value)?.split('-');
                      return `${valueArr[1]}/${valueArr[2]}/${valueArr[0]}`;
                    } else {
                      return '';
                    }
                  }
                  default:
                    return value;
                }
              })()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardRow;